import { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { Grid } from "@mui/material";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../Context/LogicContext";
import { SetEditCreditNoteAtom, GetCreditNoteListAtom, SetCreditNoteListAtom } from "../../store/CreditNoteStore";
import { ImAttachment } from "react-icons/im";
import { FaFilePdf } from "react-icons/fa";
import { MdDelete, MdEdit } from "react-icons/md";
import { IoPrintSharp } from "react-icons/io5";
import { creditNoteService } from "../../services/creditNoteService";
import { useReactToPrint } from 'react-to-print';
import { walletTransService } from "../../services/walletTransService";
import WalletTransScroll from "./WalletTransScroll";
import TransactionCard from "./TransactionCard";

function WalletTransDetailsPage() {
  const myPromiseModal = createModal(GeneralModal);
  const setCreditNoteEdit = SetEditCreditNoteAtom();
  const getCreditNoteListAtom = GetCreditNoteListAtom();
  const setCreditNoteListAtom = SetCreditNoteListAtom();
  
  const logicContext = useContext(LogicContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const componentRef = useRef();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const [walletTransDetails, setWalletTransDetails] = useState({});

  useEffect(() => {
    let isMounted = true;
    loadDetails(id, isMounted);
    return () => {
      isMounted = false;
    };
  }, [id]);

  const loadTableList = () => {
    creditNoteService.creditNoteList().then(res => {
      if (res.data) {
        setCreditNoteListAtom(res.data);
      }
    });
  }

  const loadDetails = async (id) => {
    try {
      const response = await walletTransService.walletDetails(id);
      if (response.data?.length) {
        const walletData = response.data[0];
        setWalletTransDetails(walletData);
      }
    } catch (error) {
      console.log('Error ', error);
    }
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Wallet Transaction ${id}`,
    pageStyle: `
      @media print {
        body { margin: 0; padding: 0; }
        .print-content { margin: 0; padding: 0; }
      }
    `,
  });

  return (
    <>
      <section className="">
        <section className="flex flex-wrap justify-between">
          <div className="mt-3"></div>

          <div className="flex flex-row flex-wrap items-center">
            <div className="mt-5 flex flex-row items-center mr-6"></div>
            <div className="mt-3 flex fle-row items-center space-x-1 ">
              <div className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
                <ImAttachment className="h-[20px] w-[20px] flex-shrink-0 text-gray-600" />
              </div>

              <div className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
                <FaFilePdf onClick={handlePrint} className="h-[20px] w-[20px] flex-shrink-0 text-gray-600" />
              </div>

              <div className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
                <IoPrintSharp onClick={handlePrint} className="h-[23px] w-[23px] flex-shrink-0 text-gray-600" />
              </div>
            </div>
          </div>
        </section>
        <section className="mt-4 lg:flex space-x-1">
          <div className="lg:w-[210px]">
            <WalletTransScroll></WalletTransScroll>
          </div>
          <section className="w-full overflow-x-hidden mt-4 lg:mt-0 lg:pl-4 ">
            {/* Wrap TransactionCard with a div that has the ref */}
            <div ref={componentRef} className="print-content">
              <TransactionCard data={walletTransDetails} />
            </div>
          </section>
        </section>
      </section>
    </>
  );
}

export default WalletTransDetailsPage;